import { useEffect } from 'react';

/**
 * Hook to set canonical URL for the current page
 * Helps Google identify the preferred version of duplicate pages
 * 
 * @param path - The canonical path (e.g., '/dashboard'). If not provided, uses current URL
 * @example
 * useCanonical('/dashboard');
 */
export const useCanonical = (path?: string) => {
  useEffect(() => {
    const canonicalUrl = path 
      ? `https://nabhos.com${path}`
      : window.location.href;
    
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }, [path]);
};
